module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full flex col-grow"
  }, [_c('div', {
    ref: "googleMap",
    staticClass: "google-map",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "top": "0",
      "left": "0",
      "right": "0",
      "bottom": "0"
    }
  }), _vm._v(" "), (Boolean(this.google) && Boolean(this.map)) ? [_vm._t("default", null, {
    "google": _vm.google,
    "map": _vm.map
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e2a071","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/components/CallCenterMap.vue
// module id = 1731
// module chunks = 17